import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-227c72ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "pause-pro-modal__text mb-0"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pause-pro-modal__text mb-2" }, " Ваша подписка ПРО находится на паузе, поэтому функция «Онлайн-доска» недоступна. ", -1))
const _hoisted_3 = { class: "pause-pro-modal__text mb-0" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pause-pro-modal__text mb-2" }, " Во время паузы действует бесплатный тариф с ограничением до 3 учеников. ", -1))
const _hoisted_5 = { class: "pause-pro-modal__text mb-0" }

import { computed, ref } from 'vue';
import TariffNotificationModal from '../../TariffNotificationModal.vue';

type PauseFeature = 'calls' | 'board' | 'students';


export default /*#__PURE__*/_defineComponent({
  __name: 'PauseProModal',
  props: {
    feature: {},
    pauseReturnDeadline: {},
    showNavigateOnClose: { type: Boolean, default: true }
  },
  emits: ["resume", "cancel", "hidden"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const modalRef = ref<InstanceType<typeof TariffNotificationModal> | null>(null);

const formattedDeadline = computed(() => {
    if (!props.pauseReturnDeadline) {
        return '';
    }

    const date = new Date(props.pauseReturnDeadline);
    if (Number.isNaN(date.getTime())) {
        return props.pauseReturnDeadline;
    }

    return date.toLocaleDateString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });
});

  const pauseReturnText = computed(() => {
    if (!formattedDeadline.value) {
      return 'Вы можете вернуться к ПРО в любой момент и сохранить прежние условия.';
    }

    return `Вы можете вернуться к ПРО в любой момент до ${formattedDeadline.value} и сохранить прежние условия.`;
  });

function showModal() {
    modalRef.value?.show();
}

function hideModal() {
    modalRef.value?.hide();
}

__expose({
    show: showModal,
    hide: hideModal,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TariffNotificationModal, {
    ref_key: "modalRef",
    ref: modalRef,
    class: "pause-pro-modal",
    title: "Подписка ПРО на паузе",
    "button-text": "Возобновить",
    "secondary-button-text": "Отменить",
    "max-width": 450,
    onButtonClick: _cache[0] || (_cache[0] = ($event: any) => (emit('resume'))),
    onSecondaryButtonClick: _cache[1] || (_cache[1] = ($event: any) => (emit('cancel'))),
    onHidden: _cache[2] || (_cache[2] = ($event: any) => (emit('hidden')))
  }, {
    default: _withCtx(() => [
      (_ctx.feature === 'calls')
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, " Ваша подписка ПРО находится на паузе, поэтому функция «Звонки» недоступна. " + _toDisplayString(pauseReturnText.value), 1))
        : (_ctx.feature === 'board')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_2,
              _createElementVNode("p", _hoisted_3, _toDisplayString(pauseReturnText.value), 1)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _hoisted_4,
              _createElementVNode("p", _hoisted_5, _toDisplayString(pauseReturnText.value), 1)
            ], 64))
    ]),
    _: 1
  }, 512))
}
}

})